import React from 'react';
import PropTypes from 'prop-types';
import { CirclePlus } from 'tabler-icons-react';
import { Anchor, Tooltip } from '@mantine/core';
import AppFlexbox from './AppFlexbox';
import AppText from './AppText';
import AppStack from './AppStack';
import classes from '../../styles/nestedStyles.module.css';

const SettingSelector = ({
  title,
  description,
  descriptionColor,
  subDescription,
  subDescriptionColor,
  icon,
  leftSection,
  leftSectionWidth,
  rightSection,
  withBorder,
  onClick,
  onRemove,
  disabled,
  disabledMessage,
  children,
  ...rest
}) => (
  <Tooltip
    disabled={!disabled || !disabledMessage}
    label={disabledMessage}
    multiline
    w={200}
    withArrow
  >
    <AppFlexbox
      className={!disabled ? classes['hover-action-card'] : null}
      onClick={
        onClick
          ? () => {
              if (!disabled) {
                onClick();
              }
            }
          : undefined
      }
      {...rest}
      style={{
        flex: 1,
        padding: 8,
        gap: 8,
        borderRadius: 8,
        backgroundColor: disabled ? '#c8cbcf' : 'rgba(240, 240, 240, 1)',
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default',
        alignItems: 'center',
        border: withBorder ? 'solid 1px lightgrey' : 'none',
        color: '#000',
        textDecoration: 'none',
        ...rest.style
      }}
    >
      <AppStack
        style={{
          border: leftSection ? 'none' : 'dashed 2px #666',
          height: leftSectionWidth ?? 50,
          width: leftSectionWidth ?? 50,
          borderRadius: 8,
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        {leftSection ?? icon}
      </AppStack>

      <AppFlexbox style={{ flex: 1, alignItems: 'center' }}>
        <AppStack style={{ flex: 1, gap: 0 }}>
          <AppText style={{ fontSize: 14, fontWeight: 500 }}>{title}</AppText>

          {typeof description === 'string' ? (
            <AppText
              style={{ fontSize: 13, color: descriptionColor ?? '#666' }}
            >
              {description}
            </AppText>
          ) : (
            description
          )}

          {typeof subDescription === 'string' ? (
            <AppText
              style={{ fontSize: 13, color: subDescriptionColor ?? '#666' }}
            >
              {subDescription}
            </AppText>
          ) : (
            subDescription
          )}
        </AppStack>
        {onRemove ? (
          <Anchor
            c="red"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onRemove();
            }}
            style={{ fontSize: 14 }}
          >
            Remove
          </Anchor>
        ) : (
          !disabled &&
          (rightSection ?? <CirclePlus color="dodgerblue" size={24} />)
        )}
      </AppFlexbox>
      {children}
    </AppFlexbox>
  </Tooltip>
);

SettingSelector.propTypes = {
  children: PropTypes.node,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  descriptionColor: PropTypes.string,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  icon: PropTypes.node,
  leftSection: PropTypes.node,
  leftSectionWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  rightSection: PropTypes.node,
  subDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subDescriptionColor: PropTypes.string,
  title: PropTypes.string,
  withBorder: PropTypes.bool
};

export default SettingSelector;
